/**
 * @typedef {Object} Role
 * @property {string} name - The role name
 */

/**
 * @typedef {Object} User
 * @property {string} name - The user's full name
 * @property {string} email - The user's email address
 * @property {Array<Role>} roles - Array of roles assigned to the user
 */

/**
 * @typedef {Object} SearchState
 * @property {boolean} isSearching - Boolean indicating if a search is active
 * @property {string|null} lowered - The lowercase search term, or null if no search
 */

/**
 * Filter users based on search term matching name, email, or role names.
 * Performs case-insensitive matching against user name, email, and all role names.
 * Returns all users when no search is active.
 *
 * @param {User} user - The user object to check against the search filter
 * @param {SearchState} searchState - The search state containing search term and status
 * @returns {boolean} Boolean indicating if the user matches the search filter
 */
export const filterUsers = (user, searchState) => {
  if (!searchState.isSearching) return true

  return (
    user.name.toLowerCase().includes(searchState.lowered) ||
    user.email.toLowerCase().includes(searchState.lowered) ||
    user.roles.map(role => role.name.toLowerCase()).filter(role => role.includes(searchState.lowered))
      .length > 0
  )
}
